import { useSelector } from "react-redux";
import { Mui } from "@osu/react-ui";
import { selectSessionLabel } from "../../../../util/selectors";

function DescriptionTerm({ year, period, sx, ...rest }) {
  const label = useSelector(state => selectSessionLabel(state, year, period));

  return (
    <Mui.Typography component="dt" fontWeight="bold" {...rest}>
      {label}
    </Mui.Typography>
  );
}

export default DescriptionTerm;
